import { ROUTES } from '@router'

export const PAGE_TYPE_BY_ROUTE_NAME = {
  [ROUTES.CMS.ARTICLE]: 'article',
  [ROUTES.CMS.BRAND_STORE]: 'brand-store',
  [ROUTES.CMS.BRAND_STORE_CATEGORY]: 'brand-store',
  [ROUTES.CMS.BUSINESS]: 'business-page',
  [ROUTES.CMS.BUYBACK]: 'buyback',
  [ROUTES.CMS.BUYBACK_CATEGORY]: 'buyback',
  [ROUTES.CMS.EVENT]: 'event-page',
  [ROUTES.CMS.LEGAL_PREVIOUS_VERSION]: 'legal-document',
  [ROUTES.CMS.LEGAL_PAGE]: 'legal-page',
  [ROUTES.CMS.SELLER]: 'seller',
  [ROUTES.CMS.STATEMENT]: 'core',
  [ROUTES.CMS.THE_X]: 'the-x',
  [ROUTES.HOME]: 'core',
}

export const PAGE_NAME_BY_ROUTE_NAME = {
  [ROUTES.CMS.STATEMENT]: 'accessibility-statement',
  [ROUTES.HOME]: 'home',
}
